// extracted by mini-css-extract-plugin
export const details = "project-details-module--details--1tNzN";
export const html = "project-details-module--html--3YwDw";
export const featured = "project-details-module--featured--3OUDF";